import React, { useEffect } from "react";
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official';
import HC_exporting from 'highcharts/modules/exporting'
import HC_anotations from 'highcharts/modules/annotations'
import exportFromJSON from 'export-from-json';
import Theme from "highcharts/themes/grid-light";
require("highcharts/modules/export-data")(Highcharts);
HC_exporting(Highcharts)
HC_anotations(Highcharts)
Theme(Highcharts)

const GridLight:  any = (props:any) => {
    // console.log(props.allData);
    let buttons = Highcharts.getOptions().exporting?.buttons?.contextButton?.menuItems?.slice();
	buttons?.push("label");
    const {allData,exportarImagen, exportExcel, labels, title, idChart, activeButton, colores} = props;
    const options = {
		chart: {
            type: 'area',
            zoomType: 'x',
            panning: true,
            backgroundColor: '#ffffff',
            panKey: 'shift',
            height:500,
            scrollablePlotArea: {
                minWidth: 700
            }
        },

		title: {
			text: title,
            style: {
				color: '#19355F',
				fontFamily: 'Montserrat-SemiBold',
				fontSize: '14px',
				
			}
		},
        subtitle:{
            text:'Indicador de 0 a 100. 50 es el punto medio. Bajo 50 puntos es escenario pesimista y sobre 50 escenario optimista.',
			style: {
				fontSize: '10px',
				color: '#19355F',
				fontFamily: 'Montserrat-Medium',
				width: '80%',
				wordBreak: 'break-word'
			}
			
        },
        xAxis: {
            gridLineWidth: 0,

            categories: labels,
            minRange: 10,
            labels:{
				style: {
					fontFamily: 'Montserrat, sans-serif',
					color: '#19355F',
					fontSize: '10px',

				  }
			}
        },
        legend: false,
    
        yAxis: {
            minorGridLineWidth: 0,
			gridLineWidth: 0,
            maxPadding:1.2,
            minPadding:1,
            tickInterval:10,
            labels:{
				format: '{value}',
                style: {
					fontFamily: 'Montserrat, sans-serif',
					color: '#19355F',
					fontSize: '10px',

				  }
			},
            title: {
                text: null
            },
        },

        annotations: [{
            draggable: '',
            labelOptions: {
                verticalAlign: 'top',
                
                y: 15
            },
            labels: [{
                point: {
                    xAxis: 0,
                    yAxis: 0,
                    x: 0,
                    y: 54
                },
                text: 'Gobierno Piñera II',
                style: {
                    textAlign: 'center',
                }
            }, {
                point: {
                    xAxis: 0,
                    yAxis: 0,
                    x: 7,
                    y: 47
                },
                text: 'Caso Catrillanca',
                
            },{
                point: {
                    xAxis: 0,
                    yAxis: 0,
                    x: 18,
                    y: 44
                },
                x:-40,
                text: 'Crisis Social 18O'
            },{
                point: {
                    xAxis: 0,
                    yAxis: 0,
                    x: 30,
                    y: 36
                },
                text: 'Plebiscito de entrada'
            },{point: {
                xAxis: 0,
                yAxis: 0,
                x: 37,
                y: 35
            },
            text: 'Mega Elección'
            },{
                point: {
                xAxis: 0,
                yAxis: 0,
                x: 43,
                y: 35.8
            },
            text: 'Presidencial 2022'
        }
        ,{
            point: {
            xAxis: 0,
            yAxis: 0,
            x: 50,
            y: 44
        },
        text: '1era Cuenta Pública'
        }
        // ,{
        //     point: {
        //     xAxis: 0,
        //     yAxis: 0,
        //     x: 51,
        //     y: 44
        // },
        // text: 'Entrega de proyecto Nueva Constitución'
        // }
        ,{
            point: {
            xAxis: 0,
            yAxis: 0,
            x: 56,
            y: 41
        },
        text: 'Nuevo acuerdo constitucional'
        },{
            point: {
                xAxis: 0,
                yAxis: 0,
                x: 66,
                y: 41
            }
            , text: 'Panamericanos'
        }
        ,{
            point: {
                xAxis: 0,
                yAxis: 0,
                x: 70,
                y:39
            }
            , text: 'Fallecimiento Presidente Piñera'
        }
        
        // ,{
        //     point: {
        //     xAxis: 0,
        //     yAxis: 0,
        //     x: 57,
        //     y: 41
        // },
        // text: 'Incendios Forestales'
        // }
        ]
        }, {
            draggable: '',
            labels: [{
                point: {
                    xAxis: 0,
                    yAxis: 0,
                    x: 23,
                    y: 28
                },
                
                text: 'Covid19'
            }, {
                point: {
                    xAxis: 0,
                    yAxis: 0,
                    x: 27,
                    y: 36
                },
                text: 'Primer Retiro 10%'
            },{point: {
                xAxis: 0,
                yAxis: 0,
                x: 34,
                y: 38
            },
            text: 'Plan de vacunación Covid19'
            },{
                point: {
                xAxis: 0,
                yAxis: 0,
                x: 44,
                y: 38.7
            },
            text: 'Gabriel Boric electo presidente'
            },{
                point: {
                xAxis: 0,
                yAxis: 0,
                x: 53,
                y: 44
            },
            text: 'Triunfo del rechazo'
            },{
                point: {
                xAxis: 0,
                yAxis: 0,
                x: 62,
                y: 39
            },
            text: 'Caso Democracia Viva'
            },{
                point: {
                xAxis: 0,
                yAxis: 0,
                x: 68,
                y: 42
            },
            text: 'Plebiscito Constitucional'
            },
            ,{
                point: {
                xAxis: 0,
                yAxis: 0,
                x: 74,
                y: 44
            },
            text: '3era Cuenta Pública'
            }
            ]
        
        }],

        plotOptions: {
			series: {
                color:'purple',
				dataLabels: {
				align: 'right',
				enabled: true,
				inside: false,
				},
				grouping: true
			}
		},

        series:allData,
        
        tooltip: {
			shared: true,
			useHTML: true,
			headerFormat: '<table><tr><th colspan="2">{point.key}</th></tr>',
			pointFormat: '<tr><td>ICP: </td>' +
				'<td style="text-align: right"><b>{point.y}</b></td></tr>',
			footerFormat: '</table>',
			valueDecimals: 0
		},

		
		  
		  lang: {
			downloadCSV: 'Descargar CSV',
			downloadJPEG: "Descargar JPEG",
			downloadPDF: "Descargar PDF",
			downloadPNG: "Descargar PNG",      
			downloadSVG: "Descargar SVG",
			downloadXLS: "Descargar XLS",
			exitFullscreen: "Salir de pantalla completa",
			viewFullscreen: "Ver Pantalla Completa",
			printChart: "Imprimir Gráfico"
		  },

		  exporting: {
			enabled: activeButton, 
			menuItemDefinitions: {
				// Custom definition
				label: {
					onclick: (event:any) => {
						console.log('clic boton custom');
						exportExcel({titulo: title, id: idChart});
					},
					text: 'Descargar XLSX'
				},
                descargarImagen: {
					onclick: (event:any) => {
						console.log('clic boton custom');
						exportarImagen();
					},
					text: 'Descargar Imagen'
				},
			},
			
			buttons: {
				contextButton: {
					menuItems: [
						"descargarImagen",
						"separator",
						"label"
					]
				}
			}
		},
		credits: {
			enabled: false
		}
	}

    return (
        <>
            <HighchartsReact highcharts={Highcharts} options={options}/>
        </>
    )
}

export default GridLight;

